import React, { useEffect } from "react";
import MenuImage from "../../components/MenuImage/MenuImage";
import "../IndexPage/IndexPage.css";

function WhiskyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="whisky-background"></div>
      <div className="card-container">
        <MenuImage
          width="1061" height="1500"
          className="pdf-sake"
          es="img/whisky.webp"
          en="img/whisky_en.webp"
          ja="img/whisky_ja.webp"
          alt="Whisky japonés"
        />
      </div>
    </div>
  );
}

export default WhiskyPage;
